/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react'
import tw from 'tailwind-styled-components'

const TableBody = tw.tbody`
  bg-white
`

export default TableBody
